import { compose } from 'lodash/fp'
import HtmlSpecialCharsDecode from './HtmlSpecialCharsDecode'

export default compose(HtmlSpecialCharsDecode)
